import Api from "@/services/api";
import { Filter, Stage, StageFilters, StageInfo } from "./types";

export async function getStages(filter: Filter): Promise<Array<Stage>> {
    return new Promise((resolve, reject) => {
        Api.post("/stage/filtered", filter).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export async function getStage(id: string): Promise<Stage> {
    return new Promise((resolve, reject) => {
        Api.get(`/stage/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createStage(model: Stage): Promise<string> {
    return new Promise((resolve, reject) => {
        Api.post("/stage", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateStage(model: Stage): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/stage", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteStage(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/stage/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDelete(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        Api.get(`/stage/checkDelete/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function GetStageInfo(id: string): Promise<StageInfo> {
    return new Promise((resolve, reject) => {
        Api.get(`/stage/info/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getFilters(): Promise<StageFilters> {
    return new Promise((resolve, reject) => {
        Api.get(`/stage/filters`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
